import { connect } from "vuex-connect";
// import log from 'loglevel';
import { ComicInfoForm } from "../../../components";

export default connect({
  stateToProps: {
    title: state => state.uploadContents.title,
    description: state => state.uploadContents.description,
    pageProgressionDirection: state =>
      state.uploadContents.pageProgressionDirection,
    isUploadIceContents: state => state.uploadContents.isUploadIceContents,
    isUpdatedImage: state => state.uploadContents.isUpdatedImage,
    isUpdatedHybrid3dSettings: state =>
      state.uploadContents.isUpdatedHybrid3dSettings,
    images: state => state.uploadContents.images,
    previewUrl: state => state.uploadContents.previewUrl,
    contentsAspectRatio: state => state.uploadContents.contentsAspectRatio,
    coverHardness: state => state.uploadContents.coverHardness,
    coverProcess: state => state.uploadContents.coverProcess,
    bodyPaperType: state => state.uploadContents.bodyPaperType,
    isDefaultHybrid3d: state => state.uploadContents.isDefaultHybrid3d
  },
  gettersToProps: {
    spineImageHeightMM: "uploadContents/spineImageHeightMM",
    spineImageWidthMM: "uploadContents/spineImageWidthMM",
    spineImageUrl: "uploadContents/spineImageUrl"
  },
  actionsToProps: {
    preview: dispatch => dispatch("uploadContents/preview"),
    previewProgress: dispatch => dispatch("uploadContents/previewProgress"),
    putDraft: dispatch => dispatch("uploadContents/putDraft"),
    updateHybrid3dSettings: dispatch =>
      dispatch("uploadContents/updateHybrid3dSettings")
  },
  methodsToEvents: {
    changeTitle: ({ commit }, value) =>
      commit("uploadContents/updateTitle", value),
    changeDescription: ({ commit }, value) =>
      commit("uploadContents/updateDescription", value)
  },
  mutationsToProps: {
    updateCoverHardness: "uploadContents/updateCoverHardness",
    updateCoverProcess: "uploadContents/updateCoverProcess",
    updateBodyPaperType: "uploadContents/updateBodyPaperType",
    updateIsDefaultHybrid3d: (commit, value) =>
      commit("uploadContents/updateIsDefaultHybrid3d", value),
    updateAspectRatioType: "uploadContents/updateAspectRatioType"
  }
})(ComicInfoForm.name, ComicInfoForm);
